import { gql } from '@apollo/client'

// The fields a PublicProfileCard needs. Shared by every query that feeds a
// card (the public profile page and the career overlap listing).
export const PUBLIC_PROFILE_CARD_FIELDS = gql`
  fragment PublicProfileCardFields on PublicUserProfile {
    id
    fullName
    displayName
    firstName
    lastName
    picture
    updatedAt
    careerStatus
  }
`
